import {useState, useEffect, useRef} from 'react';
import Analytics from 'react-router-ga';
import PulsoidClient, {NotAuthorizedError} from '../../../PulsoidClient';
import {useLocation} from 'react-router-dom';
import {DashboardNavigationTopBar} from './DashboardNavigationTopBar';
import {DashboardNavigationSideBar} from './DashboardNavigationSideBar';
import {PrivateRoutes} from './DashboardRoutes';
import './DashboardNavigation.css'; // TODO: replace it with css modules approach
import {LoaderOverlay} from '../../../system/Loader/Loader';

const DashboardNavigation = () => {
  const [loading, setLoading] = useState(true);
  const [showAuthMessage, setShowAuthMessage] = useState(false);
  const [email, setEmail] = useState('');
  const [report, setReport] = useState(null);

  const client = useRef(new PulsoidClient()).current;
  const location = useLocation();

  const reportPageOpened = () => {
    client.reportPageOpened(location.pathname + location.search);
  };

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const user = await client.getUserInfo();

        setEmail(user.email);
        setIsUserStreamed(user.isUserStreamed);
        setLoading(false);

        reportPageOpened();

        // Uncomment if you need to fetch yearly report
        // const yearlyReport = await client.getYearlyReport();
        // setReport(yearlyReport);
      } catch (e) {
        if (e.name === NotAuthorizedError) {
          setShowAuthMessage(true);
          setLoading(false);
        } else {
          setLoading(false);
        }
      }
    };

    fetchUserInfo();
  }, []);

  // Effect for route changes
  useEffect(() => {
    if (!loading && !showAuthMessage) {
      reportPageOpened();
    }
  }, [location, showAuthMessage, loading]);

  if (loading) {
    return <LoaderOverlay backgroundColor="#222222" title="Loading..." />;
  } else if (showAuthMessage) {
    return (
      <LoaderOverlay
        backgroundColor="#222222"
        title="Redirecting to login..."
      />
    );
  }

  return (
    <>
      <Analytics id="UA-84370067-1" debug>
        <DashboardNavigationTopBar email={email} />
        <div className="NavSidebarContainer">
          <DashboardNavigationSideBar hasReport={!!report} />
          <PrivateRoutes />
        </div>
      </Analytics>
    </>
  );
};

export default DashboardNavigation;
